import { PRODUCTION_URLS } from '@disenchantment/shared';

/** Live application (sign-in, chat, voice). */
export const APP_URL =
  (import.meta.env.VITE_APP_URL as string | undefined)?.trim() || PRODUCTION_URLS.app;

export const SITE_URL = PRODUCTION_URLS.marketing;

export const API_BASE = import.meta.env.DEV
  ? ''
  : (import.meta.env.VITE_API_URL as string).replace(/\/$/, '');
